import { createAction } from 'redux-actions';

import { changeEnv } from 'core/api/deviceOperations';
import { addNotification } from 'core/redux/ui/actions';
import { createNotification, LEVELS } from 'shared/utilities/notification';
import { getIdToken } from 'shared/utilities/localStore';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from 'shared/constants/messages';

export const setFetchingOrders = createAction('SET_FETCHING_ORDERS');
export const setInitialDeviceLoads = createAction('INITIAL_DEVICE_LOAD');
export const setStackSelection = createAction('DEVICE_STACK_SELECTION');
export const setStackAccount = createAction('DEVICE_STACK_ACCOUNT');
export const resetOptions = createAction('RESET_OPTIONS');

export const setOrg = createAction('SET_ORG');
export const setSearchTextGlobal = createAction('SET_SEARCH_TEXT');
export const setExternalSearch = createAction('SET_EXTERNAL_SEARCH');
export const setClearSearchText = createAction('SET_CLEAR_SEARCH_TEXT');

// calls when click on refresh button from device list page
export const clearAndRestoreOrders = (orgDetails) => {
  return async (dispatch) => {
    dispatch(setFetchingOrders(true));
    dispatch(resetOrders([]));
    return dispatch(fetchOrders(undefined, undefined, orgDetails.awsAccount, orgDetails.stack));
  };
};

// to do request of change in stack of the device
export const changeDeviceEnv = (device) => {
  return async (dispatch) => {
    dispatch(requestEnvChange(device.deviceId));
    try {
      const idToken = getIdToken();
      await changeEnv(device.deviceId, { from: device.environment, to: device.destEnv }, idToken);
      dispatch(
        addNotification({
          notification: createNotification(
            LEVELS.SUCCESS,
            SUCCESS_MESSAGES.CHANGES_DEVICE_ENV,
            SUCCESS_MESSAGES.CHANGE_DEVICE_ENV_SUB
          ),
        })
      );
      return true;
    } catch (e) {
      console.log(e);
      dispatch(handleError());
      dispatch(
        addNotification({
          notification: createNotification(LEVELS.ERROR, ERROR_MESSAGES.CHANGES_DEVICE_ENV, e),
        })
      );
      return false;
    }
  };
};

// set initial loader state
export const setInitialLoads = (status) => {
  return async (dispatch) => {
    dispatch(setInitialOrgLoads(status));
  };
};

// set state when selecting Stack
export const stackSelection = (selection) => {
  return async (dispatch) => {
    dispatch(setStackSelection(selection));
  };
};

// set state when selecting Account
export const stackAccount = (selection) => {
  return async (dispatch) => {
    dispatch(setStackAccount(selection));
  };
};
